export default {
  introSection: {
    title: {
      fr: "Système GTB",
      en: "BAC System",
    },
    subtitle: {
      fr: "Petit & moyen tertiaire.",
      en: "Small to mid-sized commercial buildings.",
    },
  },
};
